import {NgModule, Component, OnChanges} from '@angular/core';
import {Input, Output,EventEmitter} from '@angular/core';
import {BrowserModule}   from '@angular/platform-browser';
import {DialogModule,ButtonModule,CalendarModule,DropdownModule,InputTextModule} from 'primeng/primeng';
import {CommonModule, DatePipe} from "@angular/common";
import {HttpModule} from "@angular/http";
import {RouterModule} from "@angular/router";
import {FormsModule} from "@angular/forms";
import {SelectItem} from "primeng/components/common/api";
import {SearchItem} from "../model/search";
import {AppPlatform} from "../model/enumModel";
import {Logger, Options, Level } from "angular2-logger/core"; // ADD THIS
import {TranslateServiceForm, TranslatePipeMoudle} from "../translate";

@Component({
  selector:'searchs',
  templateUrl:'search.component.html'
})
export class SearchComponent implements OnChanges{

  sDate: string;
  eDate: string;
  selectedSearchID : string;
  searchText : any;
  searchItem : SearchItem;

  showRegisteredDropDownBox : boolean = false;
  showAppTypeDropDownBox : boolean = false;
  showLastVersionedDropDownBox : boolean = false;
  showLockDropDownBox : boolean = false;

  registeredDropDownBox : SelectItem[];
  appTypeDropDownBox : SelectItem[];
  lastVersionedDropDownBox : SelectItem[];
  lockDropDownBox : SelectItem[];

  registerValue : boolean = true;
  appTypeValue : AppPlatform;
  lastVersionValue : boolean = true;
  lockValue : boolean = true;

  @Input() dateIsTrue;
  @Input() resetIsTrue : any ="";
  @Input() excelIsTrue : boolean = false;

  @Input() searchIDs : SelectItem[];
  @Output() passingModel = new EventEmitter();
  @Output() excelDownStatus = new EventEmitter();

  private logger : Logger = new Logger();
  translate : TranslateServiceForm;
  constructor(private _translate : TranslateServiceForm){
      this.translate = _translate;
      this.registeredDropDownBox =[];
      this.registeredDropDownBox.push({label : this.translate.instant('LANG_isRegistered'),value : true});
      this.registeredDropDownBox.push({label : this.translate.instant('LANG_NotRegistered'), value : false});

      this.appTypeDropDownBox = [];
      this.appTypeDropDownBox.push({label : 'ANDROID',value : AppPlatform.ANDROID});
      this.appTypeDropDownBox.push({label : 'IOS',value : AppPlatform.IOS});
      this.appTypeDropDownBox.push({label : 'Windows Desk',value : AppPlatform.WINDOWS_OS});
      this.appTypeDropDownBox.push({label : 'Windows mobile',value : AppPlatform.WINDOWS_PHONE});

      this.lastVersionedDropDownBox = [];
      this.lastVersionedDropDownBox.push({label: this.translate.instant('LANG_APP_Latestversion'), value : true});
      this.lastVersionedDropDownBox.push({label: this.translate.instant('LANG_APP_Not_LatestVersion'), value : false});

      this.lockDropDownBox =[];
      this.lockDropDownBox.push({label: this.translate.instant('LANG_Lock'), value : true});
      this.lockDropDownBox.push({label: this.translate.instant('LANG_Normal'), value : false});

  }
  ngOnChanges() {
    this.logger.debug("resetIsTrue : ",this.resetIsTrue);
    if(this.resetIsTrue.indexOf("true") >= -1){
      this.itemReset();
    }

    //this.resetIsTrue = false;
  }

  //초기화
  itemReset(){
    this.selectedSearchID = "all";
    this.searchText = "";
    this.registerValue = true;
    this.appTypeValue = AppPlatform.ANDROID;
    this.lastVersionValue = true;
    this.lockValue = true;
  }

  searching(){
    let datePipe = new DatePipe("en");
    if(this.selectedSearchID == "isRegistered"){
      this.searchText = this.registerValue;
    }else if(this.selectedSearchID == "appType"){
      this.searchText = AppPlatform[this.appTypeValue];
    }else if(this.selectedSearchID == "isLastVersion"){
      this.searchText = this.lastVersionValue;
    }else if(this.selectedSearchID == "isLock"){
      this.searchText = this.lockValue;
    }
    this.resetIsTrue = "false";

    this.searchItem = new SearchItem(datePipe.transform(this.sDate, 'yyyy-MM-dd'),datePipe.transform(this.eDate, 'yyyy-MM-dd'),this.selectedSearchID,this.searchText,true);
    //this.searchModel = new Model(datePipe.transform(this.sDate, 'yyyy-MM-dd'),datePipe.transform(this.eDate, 'yyyy-MM-dd'),this.selectedSearchID, this.searchText);
    this.logger.debug(datePipe.transform(this.sDate, 'yyyy-MM-dd'));
    this.logger.debug(datePipe.transform(this.eDate, 'yyyy-MM-dd'));
    this.logger.debug(this.selectedSearchID);
    this.logger.debug(this.searchText);

    this.logger.debug("value : ", this.searchItem);
    /*searchMod.searchId = this.selectedSearchID;
    searchMod.searchText = this.searchText;
    searchMod.sDate = datePipe.transform(this.sDate, 'yyyy-MM-dd');
    searchMod.eDate = datePipe.transform(this.eDate, 'yyyy-MM-dd');*/

    this.passingModel.emit(this.searchItem);

  }

  changingID(event){
    this.logger.debug("event",event);
    if(event.value =="isRegistered"){
      this.showRegisteredDropDownBox = true;
      this.showLastVersionedDropDownBox = false;
    }else if(event.value == "appType"){
      this.showAppTypeDropDownBox = true;
    }else if(event.value == "isLastVersion"){
      this.showRegisteredDropDownBox = false;
      this.showLastVersionedDropDownBox = true;
    }else if(event.value == "isLock"){
      this.showLockDropDownBox = true;
    }else{
      this.searchText = "";
      this.showAppTypeDropDownBox = false;
      this.showRegisteredDropDownBox = false;
      this.showLastVersionedDropDownBox = false;
      this.showLockDropDownBox = false;
    }
  }

  excelExport(event){
    this.excelDownStatus.emit(true);
  }

}

@NgModule({
  imports:[DialogModule,BrowserModule,ButtonModule,CommonModule,DropdownModule,InputTextModule,HttpModule, RouterModule,FormsModule,CalendarModule,TranslatePipeMoudle],
  declarations:[SearchComponent],
  exports:[SearchComponent],
  providers:[]
})
export class SearchModule{

}



// WEBPACK FOOTER //
// ./src/app/component/search.component.ts